import { toValue, type MaybeRefOrGetter } from "vue";
import { watchDebounced } from "@vueuse/core";

import type { Navigator } from "@/components/navigator/types";
import type { WPSClient } from "@/wps/client";

import eventBus from "../event-bus";

type UseEmbedResult = {
  onReady: () => void;
};

export function useEmbedModule(
  client: WPSClient,
  navigator: MaybeRefOrGetter<Navigator>
): UseEmbedResult {
  watchDebounced(
    () => toValue(navigator)?.activeLocator,
    (newLocator) => eventBus.emit("navigator:locator", newLocator),
    { debounce: 50 }
  );

  return {
    onReady: () => {
      const nav = toValue(navigator);
      if (!nav) {
        throw new Error("navigator undefined in onReady");
      }

      eventBus.emit("navigator:ready", {
        navigator: nav,
        wpsClient: client,
      });
    },
  };
}
